import React, { useMemo } from 'react';
import * as css from './textarea.module.scss';
import classNames from 'classnames';

type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  htmlId: string;
  label?: string;
};

// TODO Add label, when needed
export const Textarea: React.FC<React.PropsWithChildren<TextareaProps>> = (
  props,
) => {
  const { readOnly, className, htmlId, id, label, ...restProps } = props;
  const idToUse = useMemo(() => htmlId || id, [id, htmlId]);

  return (
    <div className={css.textareaContainer}>
      {label && idToUse && <label htmlFor={idToUse}>{label}</label>}
      {readOnly ? (
        <TextareaReadOnly {...props} />
      ) : (
        <textarea
          {...restProps}
          className={classNames(css.textarea, className)}
          id={idToUse}
        />
      )}
    </div>
  );
};

// TODO Add label, when needed
const TextareaReadOnly: React.FC<React.PropsWithChildren<TextareaProps>> = ({
  id,
  htmlId,
  value,
  className,
}) => (
  <p
    className={classNames(css.textarea, css.readOnly, className)}
    id={htmlId || id}
  >
    {value}
  </p>
);
